import { render, staticRenderFns } from "./DocumentsShow.vue?vue&type=template&id=f0995922&scoped=true&"
import script from "./DocumentsShow.vue?vue&type=script&lang=js&"
export * from "./DocumentsShow.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsShow.vue?vue&type=style&index=0&id=f0995922&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0995922",
  null
  
)

export default component.exports